/**
 * Feature flags for Pista install prompts.
 *
 * All flags default to true if omitted, so the prompts are visible once
 * REACT_APP_GOOGLE_PLAY_URL is configured. Set any flag to "false" to hide it.
 */
const env = process.env || {};

function isEnabled(value) {
  if (value === undefined || value === null || value === '') {
    return true;
  }
  const v = String(value).trim().toLowerCase();
  return v !== 'false' && v !== '0' && v !== 'off' && v !== 'no';
}

const masterEnabled = isEnabled(env.REACT_APP_ENABLE_INSTALL_PROMPTS);

export const installPrompts = {
  googlePlayUrl: env.REACT_APP_GOOGLE_PLAY_URL || '',
  enabled: masterEnabled,
  showTopNavInstall: masterEnabled && isEnabled(env.REACT_APP_SHOW_INSTALL_TOP_NAV),
  showHomeSnackbar: masterEnabled && isEnabled(env.REACT_APP_SHOW_INSTALL_HOME_SNACKBAR),
  showProfileGooglePlay: masterEnabled && isEnabled(env.REACT_APP_SHOW_INSTALL_PROFILE_GOOGLE_PLAY),
  showSettingsIOS: masterEnabled && isEnabled(env.REACT_APP_SHOW_INSTALL_SETTINGS_IOS),
};

export default installPrompts;
